import { createContext } from 'react';
import { createMongoAbility, MongoAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';

// Match backend types
export type Subjects = 'Account' | 'Activity' | 'Report' | 'Settings' | 'User' | 'Organization' | 'all';
export type Actions = 'view' | 'create' | 'update' | 'delete' | 'export' | 'manage';
export type AppAbility = MongoAbility<[Actions, Subjects]>;

// Create ability context
const AbilityContext = createContext<AppAbility | undefined>(undefined);

// Create <Can> component for React
export const Can = createContextualCan(AbilityContext.Consumer as any);

/**
 * Build ability from rules (received from backend)
 */
export function buildAbility(rules: Array<{ action: string; subject: string; conditions?: Record<string, unknown> }>): AppAbility {
  return createMongoAbility<AppAbility>(rules as any);
}

/**
 * Create default ability (no permissions)
 */
export function createDefaultAbility(): AppAbility {
  return createMongoAbility<AppAbility>([]);
}
